import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import audio from './modules/audio'

Vue.use(Vuex)
const state={

}
export default new Vuex.Store({

  modules: {
    user,
    audio
  },
  state,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js